export default values => ({
  saleProductKey: values.saleProductKey ?? ''
});
